import React, { useState } from 'react';
import './style.scss';
import useAlert from '../../../../app/src/contexts/alert';
import ControlPanelConfig from './config';
import ControlPanelStats from './stats';
import Button from '../general/controls/button';
import fetcher from '../../utils/fetcher';

interface Props {
  handle401: () => any;
}

const ControlPanel = ({ handle401 }: Props) => {
  const alert = useAlert();
  const [logoutLoading, setLogoutLoading] = useState(false);

  const handleAxiosError = (err: any) => {
    alert.showError(err);
    if (err.response?.status === 401) {
      return handle401();
    }
  };

  const logout = () => {
    setLogoutLoading(true);
    fetcher.login
      .logout()
      .then(() => {
        alert.show('🖖');
      })
      .catch(() => {
        alert.showError('Server is 👌👈');
      })
      .finally(() => handle401());
  };

  return (
    <div className='control-panel'>
      <ControlPanelConfig
        handleAxiosError={handleAxiosError}
        className='control-panel-column'
      />
      <ControlPanelStats
        handleAxiosError={handleAxiosError}
        className='control-panel-column'
      />
      <Button
        color='default'
        variant='outlined'
        loading={logoutLoading}
        className='control-panel-logout'
        onClick={logout}
      >
        ESCAPE
      </Button>
    </div>
  );
};

export default ControlPanel;
